import React from "react";

const Logo = () => {
  return (
    <div className="d-flex align-items-center gap-3">
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', fontFamily: 'Segoe UI, sans-serif' }}></div>

      <h1
        style={{
          fontSize: "1.6rem",
          fontWeight: 800,
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          letterSpacing: "-1px",
          background: "linear-gradient(to right, #ff4d4d, #f9cb28)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        <span
          style={{
            color: "#00dfd8",
            textShadow: "0 1px 5px rgba(0, 223, 216, 0.5)",
          }}
        >
          Iz
        </span>
        fakturiraj
      </h1>
    </div>
  );
};

export default Logo;
